<div id="valoracion-cliente">
  <div class="row">
    <div class="col-12">
      <div class="mh-150">
        <div><span class="material-symbols-outlined filled mat-icon-size-60 mb-3">format_quote</span></div>
        <p class="p1-semibold neutral-500 mb-3">{{valoracion.textoValoracion}}</p>
      </div>
      <p class="primary-900"><strong class="p1-bold">{{valoracion.nombrePersona}}</strong></p>
    </div>
  </div>
</div>